import React from 'react'

// Deps
import { connect } from 'react-redux';
import 'assets/scss/admin/admin.scss';
import store from "store";
import { setRouteBase } from "store/site/actions";

// Functions
import blockOverflow from 'functions/block-overflow'

// Controllers
import Navigator from 'controllers/navigator'

// Pages
import Intro from 'views/admin/pages/intro'
import Dashboard from 'views/admin/pages/dashboard'
import Login from 'views/admin/pages/login'
import Register from 'views/admin/pages/register'
import RegisterV1 from 'views/admin/pages/register-v1'
import NotFound from 'views/admin/pages/notfound'
import ErrorPage from 'views/admin/pages/error'
import Payments from 'views/admin/pages/payments'
import Products from 'views/admin/pages/products'
import ProductDetail from 'views/admin/pages/product-detail'
import Clients from 'views/admin/pages/clients'
import ClientDetail from 'views/admin/pages/client-detail'
import Orders from 'views/admin/pages/orders'
import OrderDetail from 'views/admin/pages/order-detail'
import CommerceOrders from 'views/admin/pages/commerce-orders'
import CommerceOrderDetail from 'views/admin/pages/commerce-order-detail'
import OrderPlans from 'views/admin/pages/order-plans'
import OrderPlanDetail from 'views/admin/pages/order-plan-detail'
import OrderTemplates from 'views/admin/pages/order-templates'
import OrderTemplateDetail from 'views/admin/pages/order-template-detail'
import CompanyInfo from 'views/admin/pages/company-info'
import CompanyPaymentTypes from 'views/admin/pages/company-payment-types'
import CompanyPaymentTypeDetail from 'views/admin/pages/company-payment-type-detail'
import Groups from 'views/admin/pages/groups'
import GroupDetail from 'views/admin/pages/group-detail'
import Accounts from 'views/admin/pages/accounts'
import AccountDetail from 'views/admin/pages/account-detail'
import CostReports from 'views/admin/pages/cost-reports'
import BalanceReports from 'views/admin/pages/balance-reports'
import PaymentHandler from 'views/admin/pages/payment-handler'
import ProductSettings from 'views/admin/pages/product-settings'
import Announcements from 'views/admin/pages/announcements'

// Sections
import Sidebar from 'views/admin/sections/sidebar'
import Header from 'views/admin/sections/header'
import Footer from 'views/admin/sections/footer'
import Onboarding from 'views/admin/sections/onboarding'

// Modals
import CompanyPaymentTypeModal from 'views/admin/modals/company-payment-type.js'
import CompanyPaymentTypeOrderModal from 'views/admin/modals/company-payment-type-order.js'
import CompanyPaymentInstallmentModal from 'views/admin/modals/company-payment-installment.js'
import GroupModal from 'views/admin/modals/group.js'
import LinkAccountToGroupModal from 'views/admin/modals/link-account-to-group.js'
import AccountModal from 'views/admin/modals/account.js'
import CancelOrderModal from 'views/admin/modals/cancel-order.js'
import LoadBalanceModal from 'views/admin/modals/load-balance.js'
import RefundPaymentModal from 'views/admin/modals/refund-payment.js'
import RegisterValidationModal from 'views/admin/modals/register-validation.js'
// import CreateExpressOrderModal from 'views/admin/modals/create-express-order.js'
import AdminNoteModal from 'views/admin/modals/admin-note.js'
import ReturnOrderProductModal from 'views/admin/modals/return-order-product.js'
import ReturnOrderProductPreviewModal from 'views/admin/modals/return-order-product-preview.js'
import ReturnOrderProductSummaryModal from 'views/admin/modals/return-order-product-summary.js'
import AnnouncementModal from 'views/admin/modals/announcement.js'

import CreateOrderModal from 'views/shared/modals/create-order.js'
import UpdateOrderModal from 'views/shared/modals/update-order.js'
import OrderSummaryModal from 'views/shared/modals/order-summary.js'
import ClientModal from 'views/shared/modals/client.js'
import OrderPaymentLinkModal from 'views/shared/modals/order-payment-link.js'
import OrderStoresMapModal from 'views/shared/modals/order-stores-map.js'
import ErpClientSearchModal from 'views/shared/modals/erp-client-search.js'


const pageRegistry = {
	Intro: Intro,
	Dashboard: Dashboard,
	Login: Login,
	Register: Register,
	RegisterV1: RegisterV1,
	Payments: Payments,
	Products: Products,
	ProductDetail: ProductDetail,
	Clients: Clients,
	ClientDetail: ClientDetail,
	Orders: Orders,
	OrderDetail: OrderDetail,
	CommerceOrders: CommerceOrders,
	CommerceOrderDetail: CommerceOrderDetail,
	OrderPlans: OrderPlans,
	OrderPlanDetail: OrderPlanDetail,
	OrderTemplates: OrderTemplates,
	OrderTemplateDetail: OrderTemplateDetail,
	PaymentHandler: PaymentHandler,
	NotFound: NotFound,
	ErrorPage: ErrorPage,
	//Settings
	CompanyInfo: CompanyInfo,
	CompanyPaymentTypes: CompanyPaymentTypes,
	CompanyPaymentTypeDetail: CompanyPaymentTypeDetail,
	Groups: Groups,
	GroupDetail: GroupDetail,
	Accounts: Accounts,
	AccountDetail: AccountDetail,
	CostReports: CostReports,
	BalanceReports: BalanceReports,
	ProductSettings: ProductSettings,
	Announcements: Announcements,
}

const mapStateToProps = (state, ownProps) => {
	return {
		mobileState: state.site.mobile,
		routeBase: state.site.routeBase,
		currentPage: state.site.currentPage,
		userData: state.user.data,
	};
};

export class Admin extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			sidebarOpen: false,
		}
	}

	componentDidMount() {
		store.dispatch(setRouteBase('admin'));
	}

	componentWillUnmount() {
		blockOverflow(false, 'sidebar-block-overflow');
	}

	componentDidUpdate(prevProps, prevState) {
		if((this.state.sidebarOpen && !this.props.mobileState) || prevProps.currentPage.key !== this.props.currentPage.key) {
			this.setState({ sidebarOpen: false });
		}

		if(prevState.sidebarOpen !== this.state.sidebarOpen) {
			blockOverflow(this.state.sidebarOpen, 'sidebar-block-overflow');
		}
	}

	render () {
		const pageWrap = this.props.currentPage.data.hidePageWrapper !== true && this.props.userData;

		if(this.props.routeBase === 'admin'){
			return (
				<div className={'section admin-container' + (!pageWrap ? ' no-sidebar' : '')}>
					{pageWrap &&
						<Sidebar
							onClose={() => { this.setState({ sidebarOpen: false }) }}
							open={this.state.sidebarOpen} />
					}
					<div className="container-contentwrap">
						{pageWrap &&
							<Header
								onToggleMenu={() => { this.setState({sidebarOpen: !this.state.sidebarOpen}); }}
								menuOpen={this.state.sidebarOpen} />
						}
						<div className="contentwrap-pagewrap">
							<Onboarding />
							<Navigator
								routeBase="admin"
								location={this.props.location}
								pageRegistry={pageRegistry}
								modals={
									<React.Fragment>						
										<CreateOrderModal />
										<UpdateOrderModal />
										<OrderSummaryModal />
										<GroupModal />
										<LinkAccountToGroupModal />
										<AccountModal />
										<CancelOrderModal />
										<LoadBalanceModal />
										<RefundPaymentModal />
										<RegisterValidationModal />
										{/* <CreateExpressOrderModal /> */}
										<AdminNoteModal />
										<ReturnOrderProductModal />
										<ReturnOrderProductPreviewModal />
										<ReturnOrderProductSummaryModal />
										<AnnouncementModal />

										<ClientModal />
										<CompanyPaymentTypeModal />
										<CompanyPaymentTypeOrderModal />
										<CompanyPaymentInstallmentModal />
										<OrderPaymentLinkModal />
										<OrderStoresMapModal />
										<ErpClientSearchModal />
									</React.Fragment>
								}>
							</Navigator>
							{pageWrap &&
								<Footer />
							}
						</div>
					</div>
				</div>
			)
		}
		else { return false; }
	}
}

export default connect(mapStateToProps)(Admin);